module.exports = __webpack_public_path__ + "assets/1.jpg?9e0ba91725de490418b2894e599a2c4b";